import React from 'react'
import Botao from '../../../Mantine/Botao/index.jsx'
import Group from '../../../Mantine/Group/index.jsx'
import Modal from '../../../Mantine/Modal/index.jsx'
import * as S from './styles.js'

export default function Alerta({ opened, onClose, onClick, message }) {
  return (
    <div>
      <Modal
        titulo="Atenção!"
        width={'600px'}
        type="alerta"
        opened={opened}
        positionTitle="center"
      >
        <S.ModalAlert>
          <p className="modal-alert">{message}</p>
          <Group position="center">
            <Botao label="Cancelar" variant="outline" onClick={onClose} />
            <Botao label="Confirmar" onClick={onClick} />
          </Group>
        </S.ModalAlert>
      </Modal>
    </div>
  )
}
